import consumer from "./consumer"
import { router } from '@inertiajs/react'

export const createPdfExtractionChannel = (except = [], fax = null, channel = "PdfExtractionChannel") => {
	return consumer.subscriptions.create({ channel: channel }, {
		connected() {
			// Called when the subscription is ready for use on the server
			console.log("pdf_channel connected");
		},

		disconnected() {
			window.cable.subscriptions.consumer.disconnect();

		},
		recieved(data) {
			console.log("PdfExtractionChannel recieved data:", data);
			console.log("fax ", fax);
			if (data.action === "refresh" && data.id === fax.id) {
				console.log("PdfExtractionChannel received data:", data);

				router.refresh({
					data: {
						toast: "data updated"
					}
				})
			}
		}
	})
}
